import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import expireIn from 'redux-persist-transform-expire-in';
import xssFilters from 'xss-filters';

import reducers from './reducers'; // the value from combineReducers
import {
  parseQueryParams,
  isStorageAccessible
} from './utils/utilFunctions';

const log = require('loglevel');

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const queryParams = window.location.search;
const getParentParams = parseQueryParams(queryParams, [
  'uhmParentDomain',
  'product',
  'language',
  'dtVersion',
  'viewSource',
  'showFullPage',
  'integrationType',
]);

let parentDomain;
if (getParentParams.uhmParentDomain) {
  parentDomain = xssFilters.uriQueryInUnQuotedAttr(
    decodeURIComponent(getParentParams.uhmParentDomain)
  );
} else {
  parentDomain = `${window.location.protocol}//${window.location.host}`;
}
parentDomain = parentDomain.replace(/\/$/, '');

let parentProduct;
if (getParentParams.product) {
  parentProduct = xssFilters.uriQueryInUnQuotedAttr(
    decodeURIComponent(getParentParams.product)
  );
} else {
  parentProduct = 'no_PLC';
}

let parentLanguage;
if (getParentParams.language) {
  parentLanguage = xssFilters.uriQueryInUnQuotedAttr(
    decodeURIComponent(getParentParams.language)
  );
} else {
  parentLanguage = 'no_LANG';
}

let parentDtVersion;
if (getParentParams.dtVersion) {
  parentDtVersion = xssFilters.uriQueryInUnQuotedAttr(
    decodeURIComponent(getParentParams.dtVersion)
  );
} else {
  parentDtVersion = '';
}

let parentViewSource;
if (
  getParentParams.viewSource &&
  (getParentParams.viewSource === 'true' || getParentParams.viewSource === true)
) {
  parentViewSource = 'en';
} else {
  parentViewSource = '';
}

let parentDestination;
if (
  getParentParams.showFullPage &&
  (getParentParams.showFullPage === 'true' ||
    getParentParams.showFullPage === true)
) {
  parentDestination = 'akn';
} else {
  parentDestination = '';
}

let parentIntegrationTye='';
if(getParentParams.integrationType){
  parentIntegrationTye = xssFilters.uriQueryInUnQuotedAttr(
    decodeURIComponent(getParentParams.integrationType)
  );
}

log.debug('parent integration type: ', parentIntegrationTye)

let useKeyStr = `${parentDomain}-${parentLanguage}-${parentProduct}${parentDtVersion}${parentViewSource}${parentDestination}${parentIntegrationTye && '-'+parentIntegrationTye}`;
const isLocalStorageAvailable = isStorageAccessible(() => localStorage);
const expireInTime = parentIntegrationTye === 'In-Product' ? 10 * 60 * 1000 : 5 * 60 * 1000; // expire in 5min, 10 if in product
const expirationKey = `exp_v${process.env.REACT_APP_VERSION}-${useKeyStr}`;
const persistConfig = {
  key: `uhmRoot_v${process.env.REACT_APP_VERSION}-${useKeyStr}`,
  storage: storage,
  stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
  ...(isLocalStorageAvailable && {transforms: [expireIn(expireInTime, expirationKey)]}), //check localStorage to prevents issues when UHM is seen as a third party app by the browser
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk))
);
export const persistor = persistStore(store);
